/**
 * Valid treatment groups for weblabs in the application.
 *
 * - C: Control group (typically the default experience)
 * - T1: Treatment group (new experience being tested)
 *
 * @remarks
 * When adding new treatments, follow the pattern of T{n} where n is
 * the next sequential number (e.g., T2, T3). Control group should
 * always remain as 'C'.
 */
export enum WeblabTreatment {
  C = 'C',
  T1 = 'T1',
  T2 = 'T2',
  // Add more treatments if necessary
}

/**
 * Registry of weblab IDs used in our application.
 *
 * This enum maps feature names to their corresponding weblab IDs, providing
 * a centralized reference for all weblabs in the application.
 *
 * Since the enum being empty would break type reference, a placeholder value is always present.
 *
 * @example
 * // Reference a weblab ID:
 * const id = WeblabId.LearningPathwaysLaunch;
 */
export enum WeblabId {
  __placeholder = 'PlaceholderWeblabId', // This should never be used and is only here to enforce typing even when no weblabs are active.
  // Add/Remove weblabs under here
  LearningPathwayPolyD = 'SP_SERVICES_SELLER_UNIVERSITY_LP_POLYD_INTEGRATION_1365809',
  RainforestHMDFeedback = 'SP_SERVICES_SELLER_UNIVERSITY_RAINFOREST_HMD_FEEDBACK_1368028',
}
